import { createFileRoute } from "@tanstack/react-router";
import TestDataGeneratorPage from "@/pages/TestDataGeneratorPage";

export const Route = createFileRoute("/tools/test-data-generator")({
  component: TestDataGeneratorPage,
});
